import { useEffect } from "react";

const SITE_NAME = "Maaly Affiliates";

const ROUTE_META = {
  "/": {
    title: "Maaly Affiliates | Earn Commissions Referring Merchants",
    description: "Join the Maaly affiliate program and earn 10% commission on referred merchant fees. Track performance with real-time analytics, custom referral links, and transparent earnings.",
  },
  "/login": {
    title: "Sign In | Maaly Affiliates",
    description: "Sign in to your Maaly Affiliates dashboard to track referrals, monitor earnings, and manage your referral links.",
  },
  "/signup": {
    title: "Create Account | Maaly Affiliates",
    description: "Join the Maaly affiliate program today. Create your free account and start earning 10% commission on every merchant you refer.",
  },
  "/maaly-admin-access": {
    title: "Admin Access | Maaly Affiliates",
    description: "Secure admin access to the Maaly Affiliates management portal. Manage affiliates, payouts, and program settings.",
  },
  "/app": {
    title: "Dashboard | Maaly Affiliates",
    description: "Overview of your affiliate performance. Track merchants referred, clicks, earnings, and conversion funnel in real time.",
    robots: "noindex, nofollow",
  },
  "/app/links": {
    title: "Referral Links | Maaly Affiliates",
    description: "Create and manage trackable referral links with UTM parameters for every campaign you run.",
    robots: "noindex, nofollow",
  },
  "/app/merchants": {
    title: "My Merchants | Maaly Affiliates",
    description: "View all merchants you have referred to Maaly. Track their status, volume, and your earned commissions.",
    robots: "noindex, nofollow",
  },
  "/app/earnings": {
    title: "Earnings | Maaly Affiliates",
    description: "Track your earnings breakdown, request payouts, and view your complete transaction history.",
    robots: "noindex, nofollow",
  },
  "/admin": {
    title: "Admin Overview | Maaly Affiliates",
    description: "Program performance at a glance. Monitor total affiliates, merchants, revenue, and payout activity.",
    robots: "noindex, nofollow",
  },
  "/admin/affiliates": {
    title: "Manage Affiliates | Maaly Affiliates",
    description: "View and manage all affiliate partners. Create accounts, update statuses, and review individual performance.",
    robots: "noindex, nofollow",
  },
  "/admin/merchants": {
    title: "Manage Merchants | Maaly Affiliates",
    description: "Track all referred merchants, attribute unassigned signups, and export merchant data.",
    robots: "noindex, nofollow",
  },
  "/admin/payouts": {
    title: "Payouts | Maaly Affiliates",
    description: "Review and process affiliate payout requests. Track pending, approved, and completed payments.",
    robots: "noindex, nofollow",
  },
  "/admin/settings": {
    title: "Program Settings | Maaly Affiliates",
    description: "Configure affiliate commission rates, integration endpoints, and referral link settings.",
    robots: "noindex, nofollow",
  },
  "/integration": {
    title: "Integration Docs | Maaly Affiliates",
    description: "Technical documentation for integrating the Maaly affiliate tracking system into your workflow.",
  },
};

function setMeta(name, content, property) {
  const attr = property ? "property" : "name";
  const key = property || name;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function usePageMeta(pathname) {
  useEffect(() => {
    const basePath = pathname?.replace(/\/+$/, "") || "/";
    const meta = ROUTE_META[basePath] || ROUTE_META[basePath.split("/").slice(0, 3).join("/")] || {};

    const title = meta.title || `${SITE_NAME}`;
    const description = meta.description || "Maaly affiliate program — earn commissions by referring merchants.";
    const robots = meta.robots || "index, follow";

    document.title = title;

    setMeta("description", description);
    setMeta("robots", robots);
    setMeta(null, title, "og:title");
    setMeta(null, description, "og:description");
    setMeta(null, pathname || "/", "og:url");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
  }, [pathname]);
}
